<template>
  <span v-if="id" class="assistant-feedback">
<!--    <div class="text-feedback">若无法发送好友申请，将异常提示截图到公众号，客服将处理</div>-->
    <a class="text-feedback" :href="`https://lark-survey-fc.pandateacher.com/qrcode?surveyId=contact_problem?assistantId=${id}`">若无法发送好友申请，请点击这里反馈，客服将很快处理</a>
    <!-- <template v-if="!isFeedback">
      <img class="icon" src="./assets/icon-question.svg" />添加失败？点此反馈
    </template>
    <template v-else>
      <img class="icon" src="./assets/icon-success.svg" />已反馈
    </template>-->
  </span>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { promiseLock } from '@/lib/decorates';
@Component({})
export default class AssistantFeedback extends Vue {
  @Prop({ type: [Number, String] }) id!: string | number;
  @Prop({ type: Boolean, default: false }) defaultIsFeedback!: boolean;
  isFeedback = this.defaultIsFeedback;
  @Prop({ type: String, default: '' }) feedbackLink!: string;

  @promiseLock
  handleFeedback() {
    this.feedbackLink && (location.href = this.feedbackLink);
    if (this.isFeedback) {
      return;
    }
    return window.apis
      .postGwsaleAssistantFeedback({
        assistant_id: this.id,
      })
      .then(() => {
        if (!this.feedbackLink) {
          this.isFeedback = true;
        }
      });
  }
}
</script>

<style lang="scss" scoped>
.assistant-feedback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.35);
  font-size: 24px;
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .text-feedback {
    max-width: 440px;
    text-align: center;
  }
}
</style>
